module.exports = __webpack_public_path__ + "static/media/red_logo_brushed.5bbc7db9.png";